import * as z from "zod";

import { REQUIRED_MESSAGE, dateSchema } from "components/form/utils";

export const bucketJobConfigSchema = z.object({
  amount: z
    .number({
      required_error: REQUIRED_MESSAGE,
      invalid_type_error: "Amount must be a number",
    })
    .min(0, "Amount must be in positive or 0"),
  currency: z
    .string({
      required_error: REQUIRED_MESSAGE,
    })
    .min(1, "Currency cannot be empty"),
  hours: z
    .number({
      required_error: REQUIRED_MESSAGE,
      invalid_type_error: "Hours must be a number",
    })
    .min(0, "Hours must be in positive or 0"),
  // start_date: dateSchema,
  // end_date: dateSchema,
});
// .refine((data) => data.end_date >= data.start_date, {
//   message: "End date must be after start date",
//   path: ["end_date"],
// });
